import { BaseInputFieldFilter, FilterLabelProps } from "@duosoftbg/nacid-components";
import React from "react";

const TextEnFilter = ({ label = "l.searchFilter.textEn", ...others }: FilterLabelProps) => {
  return <BaseInputFieldFilter label={label} fieldName={"textEn"} {...others} />;
};

export default TextEnFilter;
